module.exports = __webpack_public_path__ + "img/GA13Feb_Linked-18.2ed5009e.jpg";